import { PageHeader } from "@ant-design/pro-components";
import { Button, Flex, Input, InputNumber, Popconfirm, PopconfirmProps, Radio, RadioChangeEvent, StepProps, Steps } from "antd";
import { observer } from 'mobx-react';
import React, { ChangeEvent, useEffect } from "react";
import TicketTypes from "../../models/ticket-type";
import { useStore } from "../../stores/root-store";
import '../common/page-header.css';
import Divider from "antd/lib/divider";
import Subjects from "../../models/subjects";

const TicketAdd: React.FC<{ subject: Subjects }> = ({ subject }) => {

    const { subjectStores, authStore } = useStore();
    const newTicket = subjectStores[subject].newTicket;
    const ticketBar = subjectStores[subject].ticketBar;

    useEffect(() => {

        if (authStore.isAuthenticated) {
            newTicket.loadFull();
        }
    }, [newTicket, authStore.isAuthenticated]
    );

    const onChangeTicketType = (e: RadioChangeEvent) => {
        newTicket.changeTicketType(e.target.value);
    };
    const onChangeCount = (e: number | string | null) => {
        if (e) {
            newTicket.changeThematicCount(e as number);
        }
    };
    const onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
        newTicket.changeName(event.target.value);
    }
    const handleClickCreate = () => {
        newTicket.createNewTicket(ticketBar);
    }
    const handleClickMakePdf = () => {
        newTicket.makePdf();
    }
    const handleRegeneratePdf = () => {
        newTicket.regeneratePdf();
    }
    const handleClickReset = () => {
        newTicket.reset();
    }
    const handleClickFinish = () => {
        newTicket.finish();
    }
    const onConfirm: PopconfirmProps['onConfirm'] = (e) => {
        newTicket.reset();
    };

    const mappedTasks = newTicket.getTasksAsSteps();
    const halfCount = newTicket.totalTaskCount / 2;
    const halfRemainder = newTicket.totalTaskCount % 2;
    const tasks1: StepProps[] = mappedTasks.slice(0, halfCount + halfRemainder);
    const tasks2: StepProps[] = mappedTasks.slice(halfCount + halfRemainder, mappedTasks.length);

    return (
        <div className="content">
            <PageHeader title="Создание варианта" className="site-page-header" />
            {/* Начать создание варианта */}
            <Flex vertical gap="middle">
                <Radio.Group onChange={onChangeTicketType} defaultValue={newTicket.type} disabled={newTicket.id !== null}>
                    <Radio.Button value="EGE">Вариант ЕГЭ</Radio.Button>
                    <Radio.Button value="THEMATIC">Тематический</Radio.Button>
                </Radio.Group>

                {newTicket.type === TicketTypes.THEMATIC &&
                    <InputNumber min={5} max={50} placeholder="количество задач" style={{ width: 200 }} onChange={onChangeCount} value={newTicket.thematicTaskCount} />}

                {newTicket.type === TicketTypes.THEMATIC &&
                    <Input placeholder="название" style={{ width: 200 }} onChange={onChangeName} value={newTicket.name} />}

                {!newTicket.id &&
                    <Flex justify="flex-start">
                        {/* Создать вариант */}
                        <Button key="enter" type="primary" onClick={handleClickCreate}>Создать</Button>
                    </Flex>
                }

                {newTicket.id &&
                    <div>
                        <Flex justify="flex-end">
                            {/* Сбросить вариант */}
                            <Popconfirm
                                title="Сбросить задачи"
                                description="Вы уверены, что хотите сбросить задачи? Отменить это действие будет невозможно"
                                onConfirm={onConfirm}
                                okText="Да"
                                cancelText="Нет"
                            >
                                <Button danger type="primary">Сбросить</Button>
                            </Popconfirm>
                        </Flex>
                        <Divider />
                        <Flex gap="middle">
                            <Steps progressDot items={tasks1} direction="vertical" />
                            <Steps progressDot items={tasks2} direction="vertical" />
                        </Flex>
                        <Flex justify="flex-end" gap="middle">
                            {newTicket.pdfLink &&
                                <Button type='link' href={newTicket.pdfLink}>Скачать PDF</Button>
                            }
                            {/* Перегенерировать PDF */}
                            {newTicket.pdfLink &&
                                <Button type='primary' onClick={handleRegeneratePdf}>Перегенерировать PDF</Button>
                            }
                            {/* Продолжить создание и выгрузить PDF при полном заполнении */}
                            {!newTicket.pdfLink &&
                                <Button key="enter" type="primary" onClick={handleClickMakePdf}>Сформировать PDF</Button>
                            }
                            {/* Завершить формирование варианта */}
                            <Button danger onClick={handleClickFinish}>Закончить создание</Button>
                        </Flex>
                    </div>
                }
            </Flex>
        </div>
    );
};


export default observer(TicketAdd);